import React from 'react';

export const StatCard = ({ title, value, icon: Icon, trend, trendValue }) => {
  return (
    <div className="stat-card" data-testid={`stat-card-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="stat-header">
        <h3 className="stat-title">{title}</h3>
        {Icon && <Icon className="stat-icon" />}
      </div>
      <div className="stat-value" data-testid={`stat-value-${title.toLowerCase().replace(/\s+/g, '-')}`}>{value}</div>
      {trend && (
        <div className={`stat-trend ${trend === 'up' ? 'trend-up' : 'trend-down'}`}>
          {trend === 'up' ? '↑' : '↓'} {trendValue}
        </div>
      )}
    </div>
  );
};
